import React from 'react';
import PropTypes from 'prop-types';
import RpCheckBoxGroup from 'components/commons/RpCheckBoxGroup';
import useFilterStore from 'zustandStore/useFilterStore';
import { SALES, LISTINGS, RENTALS } from 'constants/comparableTypes';

const PROPERTY_TYPE_VARIATIONS = [SALES, LISTINGS];

const TypeFilter = React.memo(function PropertyTypeFilter(props) {
    const typeValues = useFilterStore(state => state.filters[props.comparableType][props.attr]);
    const setFiltersForVariations = useFilterStore(state => state.setFiltersForVariations);
    const isDefaultFilterValue = useFilterStore(state => state.isDefaultFilterValue);

    const propertyTypeVariations = props.comparableType === RENTALS ? [RENTALS] : PROPERTY_TYPE_VARIATIONS;
    const variations = props.attr === 'propertyType' ? propertyTypeVariations : [props.comparableType];

    // Sorts the array according to PropertyTypes order
    const sortByPropertyTypes = (arr) =>
        [...arr].sort(
            (a, b) =>
                props.types.findIndex(pt => pt.value === a) -
                props.types.findIndex(pt => pt.value === b)
        );

    const handleChange = (value) => {
        const updated = typeValues.includes(value)
            ? typeValues.filter(v => v !== value)
            : [...typeValues, value];
        setFiltersForVariations(variations, {
            [props.attr]: sortByPropertyTypes(updated)
        });
    };

    const clearAll = () => {
        setFiltersForVariations(variations, { [props.attr]: [] });
    };

    const selectAll = () => {
        setFiltersForVariations(variations, { [props.attr]: props.types?.map(o => o.value) });
    };

    const allSelected = typeValues.length === props.types?.length;
    const displayValue = allSelected ? '' : typeValues?.join(', ');

    return (
        <RpCheckBoxGroup
            label={props.label || 'Property Type'}
            options={props.types}
            value={typeValues}
            onChange={handleChange}
            clearAll={clearAll}
            selectAll={selectAll}
            displayValue={displayValue}
            active={!isDefaultFilterValue(props.comparableType, props.attr, typeValues)}
            isDropdown={props.isDropdown}
            columnSize={props.columnSize || 2}
            width={200}
            showValueAsTooltip
        />
    );
});

TypeFilter.propTypes = {
    label: PropTypes.string,
    types: PropTypes.arrayOf(
        PropTypes.shape({
            value: PropTypes.string.isRequired,
            label: PropTypes.string.isRequired,
        })
    ).isRequired,
    attr: PropTypes.string.isRequired,
    isDropdown: PropTypes.bool,
    comparableType: PropTypes.string.isRequired,
    columnSize: PropTypes.number,
};

export default TypeFilter;
